export default {
  setProcedures(state, processos) {
    state.procedures = processos;
  }
};
